import { collection, onSnapshot } from 'firebase/firestore';
import {useState, useEffect} from 'react';
import { db } from '../services/firebase';

const useRooms = () => {

  const [isLoading, setIsLoading] = useState(true);
  const [rooms, setRooms] = useState([]);

  useEffect(() => {
    onSnapshot(collection(db, "rooms"), (snapshot) => {
      const roomDocs = snapshot.docs.map((doc) => {
        return { ...doc.data(), id: doc.id };
      });
      setIsLoading(false);
      setRooms(roomDocs);
    });
  }, []);

  return { isLoading, rooms };
}

export default useRooms;